import { css } from '@emotion/react'
import { Icon, Theme, Tooltip, useTheme } from 'bold-ui'
import { OrigemDadoEnum } from 'graphql/types.generated'

interface OrigemAtendimentoObservacaoIconProps {
  origemAtendimento: OrigemDadoEnum
}

export const OrigemAtendimentoObservacaoIcon = (props: OrigemAtendimentoObservacaoIconProps) => {
  const { origemAtendimento } = props

  const theme = useTheme()
  const classes = styles(theme)

  const tooltipText =
    origemAtendimento === OrigemDadoEnum.CDS
      ? 'Registros de origem CDS não possuem data nem horário de inicio e fim da observação'
      : origemAtendimento === OrigemDadoEnum.RAS_PEC
      ? 'Registros de outras instalações não possuem data nem horário de inicio e fim da observação'
      : origemAtendimento === OrigemDadoEnum.SISTEMA_TERCEIRO
      ? 'Registros de sistemas terceiros não possuem data nem horário de inicio e fim da observação'
      : ''

  return (
    <Tooltip text={tooltipText} placement='bottom-end'>
      <Icon icon='infoCircleFilled' fill='normal' size={1} style={classes.infoIcon} />
    </Tooltip>
  )
}

const styles = (theme: Theme) => ({
  infoIcon: css`
    &:hover {
      fill: ${theme.pallete.primary.main};
    }
  `,
})
